import { CommunicationRecord } from "@entities";

export function partnerOrgCommunicationRecordsWhere(
  partnerOrganizationId: string,
) {
  return CommunicationRecord.hyperFilter({
    $or: [
      { partnerOrganizationId },
      { opportunity: { $is: { partnerOrganizationId } } },
      {
        opportunity: {
          $is: {
            parentOpportunity: { $is: { partnerOrganizationId } },
          },
        },
      },
    ],
  });
}
